import { render, staticRenderFns } from "./UiAvatars.vue?vue&type=template&id=b03f1800&"
import script from "./UiAvatars.vue?vue&type=script&lang=js&"
export * from "./UiAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports